import { render } from "./followCenter.vue?vue&type=template&id=ace6497e&scoped=true"
import script from "./followCenter.vue?vue&type=script&lang=js"
export * from "./followCenter.vue?vue&type=script&lang=js"

import "./followCenter.vue?vue&type=style&index=0&id=ace6497e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace6497e"]])

export default __exports__